import React, { useState } from 'react';

interface Payments {
  marca: string;
  monto: number;
  estado_pago_enum: string;
  motivo_rechazo: string;
  fecha_hora: string;
  codigo_autoriza: string
}

interface PaymentsTableProps {
  payments: Payments[];
}

const PaymentsTable: React.FC<PaymentsTableProps> = ({ payments : Payments }) => {
  
  
  const formatDate = (dateString: string): string => {
    const months = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];
    
    const [datePart] = dateString.split('T'); 
    const [year, month, day] = datePart.split('-');
    const monthIndex = parseInt(month, 10) - 1;
    const monthName = months[monthIndex];
    
    return `${day} ${monthName.charAt(0).toUpperCase() + monthName.slice(1)} ${year}`;
  };

  const statusMap = (payment: Payments) => {
    switch (payment.estado_pago_enum) {
      case 'ACEPTADO':
        return (
          <span className="bg-green-100 text-green-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-green-200 dark:text-green-900">Aceptado</span>
        );
      case 'RECHAZADO':
        return (
          <span className="bg-red-100 text-red-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-red-200 dark:text-red-900">Rechazado</span>
        )
      case 'PENDIENTE':
        return (
          <span className="bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded-full dark:bg-blue-200 dark:text-blue-900">Pendiente</span>
        )

      default:
        return 'Desconocido';
    }
  };

  const paymentMethodMap = (payment: Payments) => {
    switch  (payment.marca) {
        case 'credit_card visa':
          return (
            <span className="">Visa Credito</span>
          );
        case 'credit_card mastercard':
          return (
            <span className="">Mastercard Credito</span>
          );
        case 'credit_card amex':
          return (
            <span className="">American Express Credito</span>
          );
        case 'debit_card visa':
          return (
            <span className="">Visa Debito</span>
          );
        case 'debit_card mastercard':
          return (
            <span className="">Mastercard Debito</span>
          );
        
        default:
          return <span className="">Otras Tarjetas</span>
      }
    }

    return (

      <div className="overflow-x-auto border rounded-xl p-6 bg-white" >
        <table className="min-w-full bg-white ">
          <thead>
            <tr className="">
              <th className="py-2 px-4 border-b font-semibold">Pago N°</th>
              <th className="py-2 px-4 border-b font-semibold">Fecha de Pago</th>
              <th className="py-2 px-4 border-b font-semibold">Importe</th>
              <th className="py-2 px-4 border-b font-semibold">Medio de Pago</th>
              <th className="py-2 px-4 border-b font-semibold">Estado</th>
            </tr>
          </thead>
          <tbody className="text-sm" >
            {Payments.map((payment, index) => (
              <tr key={index}>
                <td className="py-2 px-4 border-b text-center">{index + 1}</td>
                <td className="py-2 px-4 border-b text-center" >{formatDate(payment.fecha_hora)}</td>
                <td className="py-2 px-4 border-b text-center">{payment.monto.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</td>
                <td className="py-2 px-4 border-b text-center">{'💳'}{' '} {paymentMethodMap(payment)}</td>
                <td className="py-2 px-4 border-b text-center">{statusMap(payment)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  export default PaymentsTable;